import { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { ArrowRight } from 'lucide-react';
import api from '@/lib/api';

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 4) { toast.error('Password too short'); return; }
    if (password !== confirm) { toast.error('Passwords do not match'); return; }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      toast.success('Password updated. Please sign in.');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Reset failed');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF8] flex items-center justify-center p-6" data-testid="reset-password-page">
      <div className="w-full max-w-sm animate-fade-in-up">
        <h2 className="text-2xl font-['Manrope'] font-bold text-[#2C2C2E] mb-1">Reset password</h2>
        <p className="text-sm text-[#6B7280] mb-8">Choose a new password for your account.</p>
        {!token ? (
          <p className="text-sm text-[#C4727F]" data-testid="reset-missing-token">Invalid or missing reset link. <Link to="/login" className="text-[#3A8C8C]">Back to sign in</Link></p>
        ) : (
          <form onSubmit={submit} className="space-y-5">
            <div className="space-y-2">
              <Label className="text-xs font-medium text-[#6B7280] uppercase tracking-wide">New Password</Label>
              <Input type="password" value={password} onChange={e => setPassword(e.target.value)} className="h-11 bg-white border-[#D4D0C8] rounded-xl" required data-testid="reset-password-input" />
            </div>
            <div className="space-y-2">
              <Label className="text-xs font-medium text-[#6B7280] uppercase tracking-wide">Confirm Password</Label>
              <Input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} className="h-11 bg-white border-[#D4D0C8] rounded-xl" required data-testid="reset-confirm-input" />
            </div>
            <button type="submit" disabled={loading} data-testid="reset-submit-btn" className="w-full h-11 bg-[#3A8C8C] text-white rounded-full font-medium text-sm hover:bg-[#2E7A7A] transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
              {loading ? <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" /> : <>Update Password <ArrowRight size={16} strokeWidth={1.5} /></>}
            </button>
          </form>
        )}
        <div className="mt-6 text-center"><Link to="/login" className="text-sm text-[#6B7280] hover:text-[#3A8C8C]">Back to sign in</Link></div>
      </div>
    </div>
  );
}
